import { DirectiveOptions } from 'vue';
import store from '../store';

const salesScore: DirectiveOptions = {
    bind: (el, { value: { value } }): void => {
        if (value) {
            store.commit('orm/changeSalesScore', value);
        }
        el.innerText = store.getters['orm/salesScore'];
    },
    update: (el): void => {
        el.innerText = store.getters['orm/salesScore'];
    },
};

export default salesScore;
